package com.appsyde.shared.presentation.screen.component.message.helper

import kotlinx.coroutines.suspendCancellableCoroutine
import org.w3c.files.File
import kotlin.coroutines.resume
import kotlin.coroutines.resumeWithException

/**
 * Lit le contenu d'un fichier en base64 (sans le préfixe data URL).
 * Utilisé côté UI uniquement pour les pièces jointes outbound.
 */
suspend fun readFileAsBase64(file: File): String = suspendCancellableCoroutine { cont ->
    val reader = js("new FileReader()").unsafeCast<dynamic>()
    reader.onload = {
        val result: String? = reader.result?.unsafeCast<String>()
        if (result != null) {
            val base64 = result.substringAfter(",", result)
            cont.resume(base64)
        } else {
            cont.resumeWithException(IllegalStateException("FileReader result was null"))
        }
    }
    reader.onerror = {
        cont.resumeWithException(IllegalStateException("FileReader error"))
    }
    reader.readAsDataURL(file)
}
